import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_AJOUTER_ARME_MANQUANTE,
    CONTEXT_DEROULE_ARME_RATELIER,
    CONTEXT_FICHE_SITUATION_ARME,
    CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID,
    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
    CONTEXT_VERIFIER_EXISTENCE_DOUBLON,
} from '../../constants/apiUrls.constants';
import signalerErreur from './signalerErreur';
import impressionRatelier from './ImpressionRatelier';
import signalerArmePerdueVolee from './SignalerPerdueVolee';
import demanderSuppression from './DemanderSuppression';
import demandeArmeTrouveeHeritee from './DemandeArmeTrouveeHeritee';
import ajoutArmeEnMasse from './AjoutArmeEnMasse';

const armes = combineReducers({
    recuperer: APIReducer.bind(null, CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID),
    recupererGdrParNumeroRga: APIReducer.bind(null, CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA),
    signalerErreur,
    impressionRatelier,
    signalerArmePerdueVolee,
    ajoutArmeEnMasse,
    ajouterArmeManquante: APIReducer.bind(null, CONTEXT_AJOUTER_ARME_MANQUANTE),
    recupererDeroule: APIReducer.bind(null, CONTEXT_DEROULE_ARME_RATELIER),
    demanderSuppression,
    ficheSituationArme: APIReducer.bind(null, CONTEXT_FICHE_SITUATION_ARME),
    demandeArmeTrouveeHeritee,
    verifierDoublonArme: APIReducer.bind(null, CONTEXT_VERIFIER_EXISTENCE_DOUBLON),
});

export default armes;
